import React from "react"
import { SelectButton } from 'primereact/selectbutton';
import "./selectButtonComp.css"
import PropTypes from 'prop-types';

function SelectButtonComp({ value, onChange,name, options, optionLabel, ...rest }) {
    return <SelectButton name={name} value={value} onChange={onChange} optionLabel={optionLabel} options={options}  />
}
SelectButtonComp.propTypes = {
    onChange: PropTypes.func.isRequired, // ✅ Add this line
    options:PropTypes.object.isRequired,
    value:PropTypes.object.isRequired,
    name:PropTypes.string.isRequired,
    optionLabel:PropTypes.string.isRequired,
  };
export default SelectButtonComp;